/* eslint-disable @typescript-eslint/no-explicit-any */
import { type Trello } from "../types/trello"

export async function getCardButton(
  t: Trello.PowerUp.IFrame,
  props: any
): Promise<Trello.PowerUp.CardButton[]> {
  return [
    {
      icon: props.baseUrl + props.logo.light,
      text: "Link customer",
      callback: (t: Trello.PowerUp.IFrame) => {
        return t.popup({
          title: "Link customer",
          url: t.signUrl("./link-settings.html"),
          height: 500,
        })
      }
    }
  ]
}
